import {
  SVVButton, SVVButtonCancel,
  SVVButtonCustom, SVVButtonRow
} from "@komponentkassen/svv-button";
import {Link} from "react-router-dom";
import React from "react";

type props = {
  isLoading?: boolean
  describedById?: string
  submitText: string
  backText?: string
  cancelText: string
  backUrl?: string,
  onCancel: () => void
  onBackClick?: () => void
  avbrytUrl?: string
}

const FormButtons = (
  {
    isLoading = false,
    describedById,
    submitText,
    backText,
    cancelText,
    backUrl,
    onCancel,
    onBackClick,
    avbrytUrl
  }: props) => {

  return (
    <SVVButtonRow isFormRow>
      <SVVButton
        type={"submit"}
        loading={isLoading}
        {...(isLoading && {"aria-describedby": describedById})}
      >
        {submitText}
      </SVVButton>
      {(backText && backUrl)
        ? <SVVButtonCustom
          asElement={Link}
          href={backUrl}
          hrefAttribute="to"
          color="secondary"
          onClick={onBackClick}
        >
          {backText}
        </SVVButtonCustom>
        : <></>
      }
      {avbrytUrl &&
        <SVVButtonCancel
          onClick={onCancel}
          asElement="button"
          hrefAttribute=""
          type="reset"
        >
          {cancelText}
        </SVVButtonCancel>
      }
    </SVVButtonRow>
  )
}

export default FormButtons